//#region src/types/shipmentOptions.types.ts
var e = {
	additionalInsurance: "additionalInsurance",
	cooledDelivery: "cooledDelivery",
	customLabelText: "customLabelText",
	deliverAtPostalPoint: "deliverAtPostalPoint",
	deliveryDate: "deliveryDate",
	freshFood: "freshFood",
	frozen: "frozen",
	hideSender: "hideSender",
	insurance: "insurance",
	noTracking: "noTracking",
	oversizedPackage: "oversizedPackage",
	priorityDelivery: "priorityDelivery",
	printReturnLabelAtDropOff: "printReturnLabelAtDropOff",
	requiresCashOnDelivery: "requiresCashOnDelivery",
	recipientOnlyDelivery: "recipientOnlyDelivery",
	requiresAgeVerification: "requiresAgeVerification",
	requiresReceiptCode: "requiresReceiptCode",
	requiresSignature: "requiresSignature",
	returnContributionFee: "returnContributionFee",
	returnOnFirstFailedDelivery: "returnOnFirstFailedDelivery",
	sameDayDelivery: "sameDayDelivery",
	saturdayDelivery: "saturdayDelivery",
	scheduledCollection: "scheduledCollection",
	tracked: "tracked"
};
//#endregion
export { e as t };
